/* Liviza site: sticky CTA, projectfilter, lees meer, galerij-lightbox, YouTube op klik. */
(function () {
  if (window.LvSite) return;
  var d = document;

  /* Sticky CTA op mobiel: zichtbaar na de hero, weg bij de footer */
  function sticky() {
    var bar = d.querySelector('[data-lvs-sticky]'); if (!bar) return;
    var hero = d.querySelector('.lvs-hero, .lvs-ch, .lvs-ph');
    var limit = hero ? hero.getBoundingClientRect().bottom + window.scrollY - 80 : 500;
    var foot = d.querySelector('footer, .footer, #shopify-section-footer-group, [id*="footer"]');
    function upd() {
      var y = window.scrollY, on = y > limit;
      if (on && foot) { var r = foot.getBoundingClientRect(); if (r.top < window.innerHeight - 40) on = false; }
      bar.classList.toggle('is-on', on);
      d.documentElement.classList.toggle('lvs-sticky-on', on);
    }
    window.addEventListener('scroll', upd, { passive: true }); upd();
  }

  /* Projectfilter (Alles / Kantoor / Hospitality) */
  d.addEventListener('click', function (e) {
    var b = e.target.closest('[data-lvs-filter]'); if (!b) return;
    var box = b.closest('[data-lvs-projects]'), f = b.getAttribute('data-lvs-filter');
    box.querySelectorAll('[data-lvs-filter]').forEach(function (x) { x.classList.toggle('is-on', x === b); x.setAttribute('aria-pressed', x === b); });
    box.querySelectorAll('[data-cat]').forEach(function (c) { c.hidden = f !== 'all' && c.getAttribute('data-cat') !== f; });
    box.querySelectorAll('.lvs-pgrid--play').forEach(function (g) {
      var i = 0;
      Array.prototype.forEach.call(g.children, function (c) {
        c.classList.remove('is-big', 'is-big-r'); if (c.hidden) return;
        var m = i % 9; if (m === 0) c.classList.add('is-big'); else if (m === 6) c.classList.add('is-big-r'); i++;
      });
    });
    fillAll();
  });

  /* Ankers naar secties (#lvs-sleutel) werken ook met Shopify-sectie-id's (…__sleutel) */
  d.addEventListener('click', function (e) {
    var a = e.target.closest('a[href^="#lvs-"]'); if (!a) return;
    var key = a.getAttribute('href').slice(5); if (!key || d.getElementById('lvs-' + key)) return;
    var t = d.querySelector('[id$="__' + key + '"]'); if (!t) return;
    e.preventDefault(); t.scrollIntoView({ behavior: 'smooth', block: 'start' });
  });

  /* Lees meer */
  d.addEventListener('click', function (e) {
    var b = e.target.closest('[data-lvs-more]'); if (!b) return;
    var t = d.getElementById(b.getAttribute('aria-controls')); if (!t) return;
    var open = t.classList.toggle('is-open');
    b.setAttribute('aria-expanded', open);
    var lab = b.querySelector('span'); if (lab) lab.textContent = open ? b.dataset.less : b.dataset.more;
  });

  /* Galerij: alle foto's tonen */
  d.addEventListener('click', function (e) {
    var b = e.target.closest('[data-lvs-showall]'); if (!b) return;
    var sec = b.closest('section'); sec.querySelectorAll('[data-lvs-extra]').forEach(function (x) { x.hidden = false; }); b.remove();
  });

  /* YouTube en video's pas laden bij klik */
  d.addEventListener('click', function (e) {
    var y = e.target.closest('[data-lvs-yt]');
    if (y) {
      e.preventDefault();
      y.innerHTML = '<iframe src="https://www.youtube-nocookie.com/embed/' + y.getAttribute('data-lvs-yt') + '?autoplay=1&rel=0" title="Projectvideo" allow="autoplay; encrypted-media; picture-in-picture" allowfullscreen></iframe>';
      return;
    }
    var p = e.target.closest('[data-lvs-play]');
    if (p) {
      var v = p.parentElement.querySelector('video');
      if (v) { v.controls = true; v.muted = false; v.play(); p.remove(); }
    }
  });

  /* Galerij lightbox */
  var lb, imgs = [], idx = 0;
  function show(i) {
    idx = (i + imgs.length) % imgs.length;
    lb.querySelector('img').src = imgs[idx];
    lb.querySelector('.lvs-lb__c').textContent = (idx + 1) + ' / ' + imgs.length;
  }
  function close() { if (lb) { lb.remove(); lb = null; d.documentElement.style.overflow = ''; } }
  d.addEventListener('click', function (e) {
    var a = e.target.closest('[data-lvs-gal] a'); if (!a) return;
    e.preventDefault();
    var g = a.closest('[data-lvs-gal]');
    imgs = Array.prototype.map.call(g.querySelectorAll('a'), function (x) { return x.href; });
    lb = d.createElement('div'); lb.className = 'lvs lvs-lb'; lb.setAttribute('role', 'dialog'); lb.setAttribute('aria-modal', 'true');
    lb.innerHTML = '<img alt=""><button class="lvs-lb__x" aria-label="Sluiten">&#10005;</button><button class="lvs-lb__p" aria-label="Vorige">&#8249;</button><button class="lvs-lb__n" aria-label="Volgende">&#8250;</button><div class="lvs-lb__c"></div>';
    d.body.appendChild(lb); d.documentElement.style.overflow = 'hidden';
    show(Array.prototype.indexOf.call(g.querySelectorAll('a'), a));
    lb.addEventListener('click', function (ev) {
      if (ev.target.closest('.lvs-lb__x') || ev.target === lb) close();
      else if (ev.target.closest('.lvs-lb__p')) show(idx - 1);
      else if (ev.target.closest('.lvs-lb__n')) show(idx + 1);
    });
  });
  d.addEventListener('keydown', function (e) {
    if (!lb) return;
    if (e.key === 'Escape') close(); else if (e.key === 'ArrowLeft') show(idx - 1); else if (e.key === 'ArrowRight') show(idx + 1);
  });

  /* Logo's: optisch even groot maken (gelijke oppervlakte i.p.v. gelijke hoogte) */
  function logoSize(img) {
    var w = img.naturalWidth, h = img.naturalHeight; if (!w || !h) return;
    var r = w / h, mob = window.innerWidth < 750, A = mob ? 2600 : 3400;
    var th = Math.sqrt(A / r); th = Math.max(16, Math.min(mob ? 38 : 46, th));
    var maxW = mob ? 120 : 150; if (th * r > maxW) th = maxW / r;
    img.style.height = Math.round(th) + 'px'; img.style.width = 'auto';
  }
  function logos() {
    d.querySelectorAll('.lvs-logos__i img').forEach(function (img) {
      if (img.complete) logoSize(img); else img.addEventListener('load', function () { logoSize(img); }, { once: true });
    });
  }

  /* Rasters: laatste rij netjes vullen. Geen uitgerekte kaart, maar de laatste rij(en)
     gelijk verdeeld (bijv. 3+2 wordt 3 + 2 halve breedtes, 3+1 wordt 2+2) op een 12-koloms raster. */
  function fill(g) {
    if (g.dataset.lvsFillOn) {
      g.style.gridTemplateColumns = '';
      Array.prototype.forEach.call(g.children, function (c) { c.style.gridColumn = ''; c.classList.remove('is-bal'); var m = c.querySelector('.lvs-media'); if (m && m.dataset.lvsH) { m.style.height = ''; m.style.aspectRatio = ''; delete m.dataset.lvsH; } });
      delete g.dataset.lvsFillOn;
    }
    var cs = getComputedStyle(g); if (cs.display !== 'grid') return;
    var cols = cs.gridTemplateColumns.split(' ').filter(Boolean).length; if (cols < 2 || 12 % cols) return;
    var kids = Array.prototype.filter.call(g.children, function (c) { return !c.hidden && c.offsetParent !== null; }); if (kids.length < 2) return;
    var gap = parseFloat(cs.columnGap) || 0, gr = g.getBoundingClientRect(), colW = (gr.width - gap * (cols - 1)) / cols;
    var info = kids.map(function (c) { var r = c.getBoundingClientRect(); return { el: c, top: Math.round(r.top), span: Math.max(1, Math.round((r.width + gap) / (colW + gap))) }; });
    var tops = []; info.forEach(function (i) { if (tops.indexOf(i.top) < 0) tops.push(i.top); }); tops.sort(function (x, y) { return x - y; });
    var lastRow = info.filter(function (i) { return i.top === tops[tops.length - 1]; });
    var used = lastRow.reduce(function (n, i) { return n + i.span; }, 0); if (used >= cols) return;
    if (lastRow.some(function (i) { return i.span > 1; })) return;
    var groups;
    if (lastRow.length >= 2) groups = [lastRow];
    else {
      if (tops.length < 2) return;
      var prev = info.filter(function (i) { return i.top === tops[tops.length - 2]; });
      if (prev.length !== cols || prev.some(function (i) { return i.span > 1; })) return;
      var set = prev.concat(lastRow), k = set.length;
      groups = k === 3 ? [set] : (k === 4 ? [set.slice(0, 2), set.slice(2)] : [set.slice(0, 3), set.slice(3)]);
    }
    var refH = 0; info.some(function (i) { if (i.span !== 1) return false; var m = i.el.querySelector('.lvs-media'); if (!m) return false; var r = m.getBoundingClientRect(); if (!r.width) return false; refH = r.height * colW / r.width; return true; });
    var unit = 12 / cols;
    g.style.gridTemplateColumns = 'repeat(12,minmax(0,1fr))'; g.dataset.lvsFillOn = '1';
    info.forEach(function (i) { i.el.style.gridColumn = 'span ' + (i.span * unit); });
    groups.forEach(function (grp) {
      grp.forEach(function (i) {
        i.el.style.gridColumn = 'span ' + (12 / grp.length); i.el.classList.add('is-bal');
        var m = i.el.querySelector('.lvs-media'); if (m && refH) { m.dataset.lvsH = '1'; m.style.aspectRatio = 'auto'; m.style.height = Math.round(refH) + 'px'; }
      });
    });
  }
  function fillAll() { d.querySelectorAll('[data-lvs-fill]').forEach(fill); }
  window.LvFill = fillAll;

  window.LvSite = { sticky: sticky, fill: fillAll };
  function init() { sticky(); logos(); fillAll(); }
  if (d.readyState === 'loading') d.addEventListener('DOMContentLoaded', init); else init();
  var rt; window.addEventListener('resize', function () { clearTimeout(rt); rt = setTimeout(function () { fillAll(); }, 150); });
  window.addEventListener('load', fillAll);
})();
